module.exports = {
    common: {
        "alert": "Alert",
        "submit": "Confirm submit",
        "sure": "Sure",
        "save": "Save",
        "ok": "Ok",
        "cancel": "Cancel",
        "close": "Close",
        "back": "Back",
        "result": "Result",
        "connotAccessed": "The web cannot be accessed, please contact the manager!",
        "invalid": "The page is invalid. Please scan the QR code again!",
        "selectPackage": "Please select at least one package number correctly",
        "increased": "The number of people can only be increased!",
        "moreNeed": 'This table has been placed in {beginNum} copies, and {nowNum} are currently added. Are you sure you need to add them?',
        "orderSuccess": "Your order has been sent successfully.",
        "orderstatechange": "The order status has changed, please re order.",
        "orderSuccessfully": "Order successfully!",
        "orderFailed": "Order failed!",
        "operationFailed": "Operation failed!",
        "addSuccessfully": "add successfully!",
        "pageInvalid": "The page is invalid. Please scan the QR code again!",
        "deleteConfirm": "Are you sure to delete this items?",
        "confirm":"Confirm",
        "order":"Order",
        "submitOrder":"Submit order"
    },
    login: {
        "name": "Name",
        "telephone": "Your phone",
        "begin": "Begin",
        "number": "Number",
        "beginTime": "Begin time",
        "anonymous": "Enter anonymously",
        "nameNotNull": "Name must be filled in.",
        "phoneNotNull": "Phone number must be filled in.",
        "accepetSendMsg":"Allowed to receive text messages.",
    },
    buffetselect: {
        'title': "All you can eat",
        "info":"If you are younger than 12 years old, you need to order a children's set meal. If you are older than 12, you need to order an adult set meal. How many people should fill in the buffet set meal fields below",
        "next": "Next",
        "successTip": " You have successfully ordered the buffet package. Please start to order the buffet. Thank you!",
        "startBuffet": "Start buffet",
        "more": "More",
        "refresh": "Refresh succressfully",
        "moreNumber": "More number",
        "successfulOrderTip":"Successful order",
        "dear": "Dear",
        "dinnerAsk":"How many people you have for dinner?",
        "selectDinnerNum":"Please select the number of diners",
        "moreNumBtn":"more number, required",
        "tasteRequired":"Your taste requirement, not required",
        "startOrder": "Start ordering",
        "packageAlreadySelectedTip": "The selected buffet package for this table is as follows:",
        "selectedPackagesList": "{foodName} ({quantity} portion)",
        "selectedPackagesListPlural": "{foodName} ({quantity} portions)",
        "confirmContinueOrder": "Confirm to continue ordering",
        "modifyPackageNum": "Adjust package quantity",
    },
    unavailable: {
        "enterOrder": "Enter ordering",
        "contactRestaurant": "This table has not been opened yet. Please contact the restaurant to open the table for you.",
        "closedHours": "We are currently outside business hours. Ordering is not available, please try again later.",
    },
    header: {
        "info":"Info",
         "opration":"Operation",
        "cartList": "Cart list",
        "cartListDsc": "Your shopping cart",
        "billList": "Bill list",
        "billListDsc": "Placed orders",
        "modify": "Newly",
        "modifyDsc": "New number of people",
        "artServices": "Call for service",
        "artServicesDsc": "Call the service staff",
        "confirmTips": "Confirm",
        "continueText": "If there are dishes in the shopping cart that need to be confirmed before placing an order, please confirm whether to continue to return?",
        "humanText": "Do you need to call the service personnel?",
        "selectLanguage": "Select Language",
        "calledService": "You have called the manual service, please wait patiently!",
        "calledSuccessfully":"You have successfully called, please wait for the service personnel!"
    },
    buffet: {
        "tip": "OBS! Hvis der er mere end 4 stk. sushi / forretter tilovers på bordet når i er færdige med at spise, betales kr. 15 pr. stk. Som tillægges ALL-You-Can-Eat prisen.",
        "freePark": "Free park",
        "payPark": "Pay park",
        "recommend": "Recommend",
        "checklist": "Checklist",
        "reminder": "Reminder",
        "next": "Next",
        "total": "Total",
        "share": "share",
        "startOrder": "Start order",
        "nullOrder": "You have not submitted your order, please choose the dishes to order!",
        "summary": "Summary",
        "cartList": "Cart list",
        "history": "History",
        "served": "Finish",
        "nserved": "Un finish",
        "description": "Description",
    },
    orderList: {
        "all": "All",
        "total": "Total",
        "refresh": "Refresh",
        "home": "Continue to order",
        "return": "Return to select dishes",
        "info": "Information",
        "frist": "First time order",
        "second": "The second order",
        "third": "The third order",
        "fourth": "The fourth order",
        "moreth": 'The {times}th order',
        "morePeople": "More people",
        "buffetBatches": "Buffet Batches",
        "orderSubmitted": "Order is being submitted, please wait!",
        "submitCart": "You have not selected dishes or your partner has confirmed to submit the shopping cart list!",
        "sendKitchen": "Send to kitchen",
        "remark": "Remark",
        "choice": "choice",
        "with": "with",
        "chooseWith": "Choose your with",
        "selectOne": "Select One",
        "oneOnlyOrder": "Max {num} portions per person.",
        "onePersonOrder": "Max {num} portions per person.",
        "maxEachTimeOrder":"Max {num} portions per round.",
        "timeLimit": "You can only order {num} at a time",
        "agreeWait": "You must agree to the waiting time before placing an order",
        "noDishes": "Cart list has no dishes, unable to submit, or please confirm it has been submitted!",
        "submittedTips": "Your order has been submitted or submitted by other partners. Please do not submit again",
        "orderClosedTips": "The order has been closed, please scan the QR code here to order, thank you!",
        "reminderTips": "The kitchen has received your reminder. Please wait 5 minutes before you send it!",
        "reminderSuccessfully": "Reminder successfully",
        "selectNumber": "You have not selected the number of people, please select the number of people and start ordering!",
        "orderChangeTip":"Order change tip",
        "deliveryType":"Delivery",
        "pickUp":"Pick up",
        "delivered":"Delivery",
        "deliveryTypeNotNull":"Please select the delivery method.",
        "dateNotNull":"Please select the order date.",
        "timeNotNull":"Please select the order time.",
        "orderDate":"Order date",
        "orderTime":"Order time",
        "name":"Name",
        "telephone":"Telephone",
        "email":"Email",
        "postNummer":"Post number",
        "postBy":"Post name",
        "address":"Address",
        "number":"Number",
        "adult":"Adults",
        "children":"Children",
        "specielle":"Remarks",
        "telephoneNotNull":"Please input the phone number",
        "nameNotNull":"Please enter your name",
        "emailNotNull":"Please enter an email",
        "numberNotNull":"Please enter the number of people",
        "postNummerNotNull":"Please enter the post number",
        "postByNotNull":"Please enter the post name",
        "addressNotNull":"Please enter the post address",
        "customerInfo":"Order information",
        "methodAndTime":"Delivery and time",
        "orderNo":"Pickup code",
        "deliveryFee":"Meal delivery fee",
        "orderNotNull":"You have not ordered any dishes. Please go back and select the corresponding dishes",
        "orderList":"My order list",
        "subAmount":"Subtotal",
        "postAmount":"Meal delivery fee",
        "emailError":"Please enter the correct email format",
        "confirmOrder":"Comfirm order",
        "limitTimeTitle":"Timeout reminder",
        "limitTimeTips":"Dining time has exceeded the set limit. Please contact our staff for assistance. Thank you for your patronage!",
        "chargedOnceTips":"Only the first serving of this dish is charged; subsequent refills are free.",
        "foodMaxEachTimeOrder":"Dish {foodName} can only be ordered up to {num} portions per order. Please adjust the quantity and submit again. Thank you!",
        "orderingTip":"This table is in the process of being ordered, please try again slightly!",
        "personNum": "Number of diners",
        "maxiNum": "Max per order (portions)",
        "upperLimit": "Overall limit (portions)",
        "selectedList": "Selected list",
        "clickToSelect": "Click to select above",
        "delete": "Delete",
        "units": "Number of portions",
        "who": "Owner (optional)",
        "nullRemark": "Who ordered",
        "needMax1": "Number of portions cannot be less than 1",
        "upperMaxLimit": "Exceeds the overall limit! Maximum additional portions you can order:",
        "oneLimit": "{user} can order at most {maxPerPerson} portion(s), already ordered {userUsed} portion(s)"
    },
    result: {
        tips: "The order has been completed. Please re scan the QR code for ordering",
        closePage: "Close page",
        errorTips: "The access page is missing, please scan the QR code again to order"
    }
}


// WEBPACK FOOTER //
// ./src/assets/i18n/en.js